<template>
  <div>
    <div>
      <div>
        <InputSearch
          class="mb-3"
          @clickAdvancedSearch="showSearch = true"
          @clickSearch="onSearch"
          @clearSearch="clearSearch"
          :search="search"
          :placeholder="'ค้นหา'"
          :isSearch="isSearch"
          :clearAdvancedSearch="clearAdvancedSearch"
          showDateSearch
          showClearAdvancedSearch
          showAdvancedSearch
        />
        <v-layout row wrap dense class="mb-3">
          <v-flex xs6 style="display: flex; align-items: center">
            <Typography h2 bold label="ข้อม​ูลผู้สมัครเข้าร่วมโครงการ" />
            <div style="margin-left: 8px">{{ `(จำนวนทั้งหมด: ${pageTotal})` }}</div>
          </v-flex>
          <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-xs-right" style="display: flex; align-items: flex-end">
              <v-btn :disabled="['false'].includes($localStorage.get('can_add_member_project'))" @click="showFormAddMember = true" :loading="loading"
                :style="`color: ${$vuetify.theme.primary};  text-transform: capitalize;`"
                :color="`color: ${$vuetify.theme.primary}`" outline><i class="fas fa-plus mr-1"></i>
                เพิ่มสมาชิก
              </v-btn>
              <v-btn
                v-if="desserts.length > 0"
                variant="outlined"
                v-tooltip="'ส่งออกข้อมูล'"
                @click="modalExport = true"
                :loading="loading"
                icon
                color="#BECCDB"
                style="border-radius: 50% !important"
              >
                <img
                  src="/static/img/exportfilter.png"
                  alt
                  class="responsive-img"
                  style="height: 20px"
                />
              </v-btn>
              <exportxlsx ref="exbtn" v-model="xlsxMember" style="display: none"></exportxlsx>
              <v-btn
                variant="outlined"
                v-tooltip="'เลือกคอลัมน์'"
                icon
                :loading="loading"
                :color="drawer ? '#0C2F53' : '#BECCDB'"
                @click.stop="drawer = !drawer"
                style="border-radius: 50% !important"
              >
                <img
                  :src="`/static/img/${drawer ? 'filterColumnWhite.png' : 'filterColumnBlack.png'}`"
                  alt
                  class="responsive-img"
                  style="height: 20px"
                />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-navigation-drawer v-model="drawer" right fixed temporary style="top: 200px; padding: 20px">
        <v-list density="compact" nav>
          <v-flex xs12 style="display: flex; align-items: center; justify-content: space-between">
            <Typography h3 bold label="เลือกคอลัมน์" />
            <v-icon @click.stop="drawer = false">close</v-icon>
          </v-flex>
          <div style="display: flex">
            <v-flex xs10 class="mb-2 mt-2">
              <div
                style="width: 100%; display: flex; align-items: center"
                class="form-group has-search"
              >
                <div
                  style="width: 100%; display: flex; justify-content: flex-end; border-right: 0px"
                  class="form-control"
                >
                  <input
                    @change="changeSearchColumn"
                    type="search"
                    class="depainput rsu mb-0"
                    placeholder="Search"
                    name="search"
                    v-model="searchColumn"
                    style="border-radius: 0px; border-right: 0px"
                  />
                </div>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-left: 0px;
                  border-right: 0px;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  class="fa fa-times-circle form-control-feedback pointer"
                  style="color: #00000040"
                  @click="clearSearchColumn"
                ></span>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  @click="changeSearchColumn"
                  class="fa fa-search form-control-feedback"
                  style="color: #bdbdbd"
                ></span>
              </div>
            </v-flex>
          </div>
          <div style="overflow: auto; height: 380px">
            <div
              class="mt-2"
              style="display: flex"
              v-for="item in this.column"
              @click="clickShowColumn(item)"
              :key="item"
            >
              <v-checkbox
                color="#0C2F53"
                style="display: flex; flex: none !important"
                v-model="showColumn.includes(item)"
                hide-details
                dense
              >
              </v-checkbox>
              <Typography h5 :label="item" />
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          expand
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="desserts"
          select-all
          item-key="name"
          class="fixTable"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="header in props.headers"
                v-show="showColumn.includes(header.text) || header.text == ''"
                :key="header.text"
                :width="header.width"
              >
                <div
                  v-show="showColumn.includes(header.text)"
                  :style="`text-align:${header.align}`"
                >
                  {{ header.text }}
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr style="cursor: pointer" @click="showEdit(props.item), (isEdit = false)">
              <td v-show="showColumn.includes('วันที่ / เวลา')" class="text-xs-left">
                <Typography
                  style="width: 140px"
                  h5
                  :label="props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm')"
                />
              </td>
              <td
                v-show="showColumn.includes('ข้อมูลแบบฟอร์ม')"
                class="text-xs-left"
                @click.stop=""
              >
                <v-btn
                  @click.stop="showForm(props.item)"
                  class="color-white none-shadow v-btnl"
                  :class="
                    props.item.applicantstatus === 'ยกเลิกเข้าร่วมโครงการ'
                      ? 'color-mediumGrey btn-disable'
                      : 'color-gradientBlue'
                  "
                  style="height: 30px"
                  :readonly="props.item.applicantstatus === 'ยกเลิกเข้าร่วมโครงการ' ? true : false"
                >
                  {{ 'ข้อมูลแบบฟอร์ม' }}
                </v-btn>
              </td>
              <td v-show="showColumn.includes('เลขที่ใบสมัคร')" class="text-xs-left">
                <Typography h5 :label="props.item.projectno" />
              </td>

              <td v-show="showColumn.includes('รหัสสมาชิก')" class="text-xs-left">
                <Typography style="width: 150px" h5 :label="props.item.memberid" />
              </td>
              <td v-show="showColumn.includes('ชื่อ - นามสกุล')" class="text-xs-left">
                <Typography style="width: 150px" h5 :label="showName(props.item)" />
              </td>
              <td v-show="showColumn.includes('สถานะ DP')" class="text-xs-center" @click.stop="">
                <div>
                  <v-btn
                    v-if="props.item.dptype === 'DP'"
                    class="color-gradientBlue color-white none-shadow v-btnl"
                    style="border-radius: 50px !important; height: 30px"
                  >
                    {{ props.item.dptype ? props.item.dptype : '-' }}
                  </v-btn>
                  <v-btn
                    v-else-if="props.item.dptype === 'Non-DP'"
                    outline
                    color="#0C2F53"
                    style="
                      border-radius: 50px !important;
                      height: 30px;
                      background-color: #ffffff !important;
                    "
                  >
                    {{ props.item.dptype ? props.item.dptype : '-' }}
                  </v-btn>
                  <v-btn
                    v-else
                    color="#EEEEEE"
                    style="border-radius: 50px !important; height: 30px; box-shadow: none"
                  >
                    {{ props.item.dptype ? props.item.dptype : '-' }}
                  </v-btn>
                </div>
              </td>
              <!-- <td v-show="showColumn.includes('การตรวจสอบ')" class="text-xs-left">
                <div
                  small
                  :style="{
                    color: statusColor(props.item.check),
                    background: 'none',
                    width: '110px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }"
                >
                  <span class="fs-20">&#8226;</span>{{ checkLabel(props.item.check) }}
                </div>
              </td> -->
              <td v-show="showColumn.includes('รหัสโครงการ')" class="text-xs-left">
                <Typography h5 :label="props.item.depaprojectid ? props.item.depaprojectid : '-'" />
              </td>
              <td v-show="showColumn.includes('โครงการ')" class="text-xs-left">
                <Typography
                  style="width: 280px"
                  h5
                  :label="props.item.projectname ? props.item.projectname : '-'"
                />
              </td>
              <td v-show="showColumn.includes('ขั้นตอน')" class="text-xs-left">
                <Typography
                  style="width: 135px"
                  h5
                  :label="props.item.applicantstepstatus ? props.item.applicantstepstatus : '-'"
                />
              </td>
              <td v-show="showColumn.includes('ผลการตรวจสอบ')" class="text-xs-left">
                <div
                  small
                  :style="{
                    color: statusColor(props.item.applicantstatus),
                    background: 'none',
                    width: '110px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }"
                >
                  <span class="fs-20">&#8226;</span
                  >{{ projectStatusLabel(props.item.applicantstatus) }}
                </div>
              </td>
              <td
                v-show="showColumn.includes('สถานะการจ่ายเงิน')"
                class="text-xs-left"
                @click.stop=""
              >
                <v-btn
                  v-if="props.item.applicant_paymentstatus === 'จ่ายเงินแล้ว'"
                  :disabled="['false'].includes($localStorage.get('can_change_payment_status'))"
                  @click.stop="statusPaymentEdit(props.item.applicantid, 'ยังไม่จ่ายเงิน')"
                  class="color-gradientBlue color-white none-shadow v-btnl"
                  style="border-radius: 50px !important; height: 30px; color: white !important"
                >
                  {{
                    props.item.applicant_paymentstatus ? props.item.applicant_paymentstatus : '-'
                  }}
                </v-btn>
                <v-btn
                  v-else
                  :disabled="['false'].includes($localStorage.get('can_change_payment_status'))"
                  @click.stop="statusPaymentEdit(props.item.applicantid, 'จ่ายเงินแล้ว')"
                  outline
                  color="#0C2F53"
                  style="
                    border-radius: 50px !important;
                    height: 30px;
                    background-color: #ffffff !important;
                  "
                >
                  <!-- {{ props.item.applicant_paymentstatus ? props.item.applicant_paymentstatus : '-' }} -->
                  {{ 'ยังไม่จ่ายเงิน' }}
                </v-btn>
              </td>
              <td v-show="showColumn.includes('สลิป')" class="text-xs-center">
                <div
                  v-if="props.item.applicant_payment_transaction_id"
                  style="text-decoration: underline; width: 55px; color: #26588b"
                  @click.stop="checkPaymentTransaction(props.item.applicant_payment_transaction_id)"
                >
                  ดูสลิป
                </div>
                <div v-else>-</div>
              </td>
              <td v-show="showColumn.includes('อีเมล')" class="text-xs-left">
                <Typography
                  style="width: 200px; word-break: break-word"
                  h5
                  :label="props.item.email ? props.item.email : '-'"
                />
              </td>
              <td v-show="showColumn.includes('เบอร์')" class="text-xs-left">
                <Typography
                  style="width: 150px"
                  h5
                  :label="props.item.phone_number ? props.item.phone_number : '-'"
                />
              </td>
              <td v-show="showColumn.includes('ประเภท')" class="text-xs-left">
                <Typography
                  style="width: 150px"
                  h5
                  :label="props.item.projecttype ? props.item.projecttype : '-'"
                />
              </td>
              <td v-show="showColumn.includes('สถานะ Odoo')" class="text-xs-left">
                <Typography
                  style="width: 150px"
                  h5
                  :label="props.item.odooinfo ? props.item.odooinfo[1].plan_status : '-'"
                />
              </td>
              <td v-show="showColumn.includes('รวม Odoo')" class="text-xs-left">
                <Typography
                  style="width: 150px"
                  h5
                  :label="
                    props.item.odooinfo && props.item.odooinfo.total
                      ? props.item.odooinfo.total
                      : '-'
                  "
                />
              </td>
              <td v-show="showColumn.includes('ข้อมูล Odoo')" class="text-xs-left" @click.stop="">
                <div
                  style="text-decoration: underline; width: 135px; color: #26588b"
                  @click.stop="showOdooInfo(props.item.odooinfo, props.item.memberid)"
                >
                  ดูข้อมูล
                </div>
              </td>
              <td v-show="showColumn.includes('ประวัติ')" class="text-xs-left" @click.stop="">
                <div
                  style="text-decoration: underline; width: 135px; color: #26588b"
                  @click.stop="clickShowLog(props.item.applicantid)"
                >
                  ดูประวัติ
                </div>
              </td>
              <td style="white-space: nowrap" @click.stop="">
                <TooltipTable
                  :datas="props"
                  @modalEdit="showEdit(props.item), (isEdit = true)"
                  @Delete="deleteApplicant(props.item.applicantid)"
                  @Print="printUser(props.item)"
                  @Download="printUserExcel(props.item)"
                  @Chat="goToLivechat(props.item.userid)"
                  showPrint
                  showDownload
                  showDelete
                  showChat
                  :showIsEdit="false"
                ></TooltipTable>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div>
          <v-dialog v-model="editModal" persistent width="600px">
            <member-info-edit
              @closemodal="closemodal"
              @saveedit="saveedit"
              v-if="editModal"
              :inputEdit="inputEdit"
              :isEdit="isEdit"
            ></member-info-edit>
          </v-dialog>
        </div>
        <v-dialog v-model="modalStatusDP" persistent width="400px">
          <v-card style="border-radius: 10px">
            <div class="pa-3">
              <div style="display: flex; justify-content: space-between">
                <div></div>
                <Typography h2 bold label="เปลี่ยนสถานะ" />
                <v-icon style="display: flex; align-items: center" @click="modalStatusDP = false"
                  >close</v-icon
                >
              </div>
              <div class="rsu">
                <v-layout row wrap>
                  <v-flex xs12 class="mb-2 mt-2 pr-1">
                    <Typography class="pr-3" h5 label="สถานะ" />
                    <div style="width: 100%" class="form-control">
                      <DropdownMenu v-model="statusDP" :options="['DP', 'Non-DP', 'รออนุมัติ DP']">
                        <input
                          placeholder="DP type"
                          type="text"
                          class="depainput rsu"
                          :value="statusDP"
                        />
                      </DropdownMenu>
                    </div>
                  </v-flex>
                </v-layout>
                <div style="display: flex; justify-content: center">
                  <Button
                    :loading="searchloading"
                    outline
                    :label="$t('cancel')"
                    @click="modalStatusDP = false"
                  />
                  <Button
                    :loading="searchloading"
                    depressed
                    :label="$t('Save')"
                    @click="editStatusDP()"
                  />
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="modalExport" persistent width="400px">
          <v-card style="border-radius: 10px">
            <div class="pa-3">
              <div style="display: flex; justify-content: space-between">
                <div></div>
                <div></div>

                <v-icon style="display: flex; align-items: center" @click="modalExport = false"
                  >close</v-icon
                >
              </div>
              <div class="rsu">
                <v-layout column wrap justify-center align-center class="mb-3">
                  <img
                    src="/static/img/Export.png"
                    alt
                    class="responsive-img mb-1"
                    style="height: 70px"
                  />
                  <Typography h2 bold label="ส่งออกข้อมูล" />
                  <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
                </v-layout>
                <div class="text-xs-center">
                  <div class="text-xs-center rsu">
                    <v-btn
                      :loading="searchloading"
                      class="rsu"
                      round
                      small
                      outline
                      color="primary"
                      @click.stop="modalExport = false"
                      >ยกเลิก</v-btn
                    >
                    <v-btn
                      class="rsu"
                      :loading="searchloading"
                      round
                      small
                      depressed
                      style="color: #ffef01"
                      color="primary"
                      @click.stop="exportData()"
                      >ยืนยัน</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="modalOdoo" width="570px" persistent>
          <v-card style="border-radius: 10px">
            <div class="pa-4">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <Typography h2 bold label="ข้อมูล Odoo" />
                <v-icon @click="modalOdoo = false">close</v-icon>
              </div>
              <div class="mt-2" v-if="currentOdoo && currentOdoo.length">
                <v-card
                  class="pa-2 mb-3"
                  v-for="(item, k) in currentOdoo"
                  :key="k"
                  style="position: relative"
                >
                  <Typography bold h6 :label="item.vendorName" />
                  <Typography h6 :label="'โครงการ' + item.projectName" />
                  <Typography h6 :label="'สถานะ :' + item.plan_status ? item.plan_status : '-'" />
                  <Typography
                    h6
                    :label="'รหัสสัญญา :' + item.contract_code ? item.contract_code : '-'"
                  />
                  <Typography
                    h6
                    :label="'เลขที่สัญญา :' + item.contractNumber ? item.contractNumber : '-'"
                  />
                  <div style="position: absolute; right: 3px; top: 2px; font-size: 14px">
                    {{ moment(item.start_date).format('DD/MM/YYYY') }} -
                    {{ moment(item.end_date).format('DD/MM/YYYY') }}
                  </div>
                  <div style="position: absolute; right: 3px; bottom: 2px">
                    <Typography
                      h6
                      :label="
                        'วันครบกำหนด :' + item.due_date
                          ? moment(item.due_date).format('DD/MM/YYYY HH:mm')
                          : '-'
                      "
                    />
                  </div>
                </v-card>
              </div>
              <div class="mt-2" v-else>
                <Typography center h5 label="ไม่มีข้อมูล" />
              </div>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showHistory" width="570px" persistent>
          <v-card style="border-radius: 10px">
            <div class="pa-4">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <Typography h2 bold label="ประวัติ" />
                <v-icon @click="showHistory = false">close</v-icon>
              </div>
              <div class="rsu">
                <v-layout row wrap>
                  <v-data-table
                    expand
                    hide-actions
                    :loading="loading"
                    :headers="[
                      {
                        text: 'วันที่ / เวลา',
                        align: 'center',
                        value: 'timestamp',
                        width: '35%'
                      },
                      {
                        text: 'Comment',
                        align: 'center',
                        value: 'comment',
                        width: '40%'
                      },
                      {
                        text: 'Action',
                        align: 'center',
                        value: 'action',
                        width: '25%'
                      }
                    ]"
                    :items="activeLog"
                    select-all
                    item-key="name"
                    class="w-100"
                  >
                    <template v-slot:headers="props">
                      <tr style="background-color: #152d53; color: white">
                        <th
                          style="background-color: #152d53; color: yellow"
                          v-for="header in props.headers"
                          :key="header.text"
                          :width="header.width"
                        >
                          <div>{{ header.text }}</div>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr style="cursor: pointer">
                        <td class="text-xs-left">
                          {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.comment ? props.item.comment : '-' }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.action ? props.item.action : '-' }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-layout>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <div>
          <v-dialog v-model="searchModal" persistent width="850px">
            <member-info-search
              @closemodal="closemodal"
              @onsearch="onsearch"
              v-if="searchModal"
              v-model="searchModal"
            ></member-info-search>
          </v-dialog>
        </div>
      </div>
    </div>

    <v-dialog v-model="showSearch" width="800px" persistent>
      <v-card style="border-radius: 10px">
        <v-btn style="float: right" @click="showSearch = false" icon><v-icon>close</v-icon></v-btn>
        <div class="pa-4">
          <div style="display: flex">
            <i class="fa fa-filter color-darkBlue" style="font-size: 18px" aria-hidden="true"></i>
            <Typography h3 semiBold label="Advanced Search" />
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="เลขที่ใบสมัคร" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="เลขที่ใบสมัคร"
                    placeholder="125665235"
                    v-model="search.projectno"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="รหัสสมาชิก" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="รหัสสมาชิก"
                    placeholder="1552366"
                    v-model="search.memberid"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ชื่อสมาชิก" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="กรอกชื่อสมาชิก"
                    placeholder="กุลสตรี"
                    v-model="search.name"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="อีเมล" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="อีเมล"
                    placeholder="อีเมล"
                    v-model="search.email"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="เบอร์" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="เบอร์"
                    placeholder="เบอร์"
                    v-model="search.phone_number"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <!-- <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="การตรวจสอบ" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu
                    :options="['uncheck', 'waitingdocument', 'sentcheck', 'checked']"
                    v-model="search.check"
                    :checktype="true"
                  >
                    <input
                      name="Check"
                      placeholder="เลือกการตรวจสอบ"
                      :value="checkLabel(search.check)"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </DropdownMenu>
                </div>
              </v-flex> -->
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ประเภท" />
                <div
                  v-if="projecttype && projecttype.length"
                  style="width: 100%"
                  class="form-control"
                >
                  <multiselect
                    :options="projecttype"
                    :custom-label="val => val.typename"
                    v-model="search.projecttype"
                    :searchable="true"
                    deselect-label=""
                    :allow-empty="false"
                    single-select
                    placeholder="เลือกประเภท"
                    @input="onProjectTypeChange"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow">
                      <v-icon class="darkBlue" aria-hidden="false" size="24px">
                        mdi-chevron-down
                      </v-icon>
                    </span>
                  </multiselect>
                </div>
              </v-flex>
              <!-- <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="รหัสโครงการ" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="กรอกรหัสโครงการ"
                    placeholder="225635652"
                    v-model="search.depaprojectid"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex> -->
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="รหัสโครงการ" />
                <div style="width: 100%" class="form-control">
                  <multiselect
                    :options="projectIdOptions"
                    v-model="search.depaprojectid"
                    :searchable="true"
                    deselect-label=""
                    :allow-empty="false"
                    single-select
                    placeholder="เลือกรหัสโครงการ"
                    @input="onDepaProjectIdChange"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow">
                      <v-icon class="darkBlue" aria-hidden="false" size="24px">
                        mdi-chevron-down
                      </v-icon>
                    </span>
                  </multiselect>
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="โครงการ" />
                <div style="width: 100%" class="form-control">
                  <multiselect
                    :options="projectOptions"
                    :custom-label="customLabel"
                    v-model="search.projectid"
                    :searchable="true"
                    deselect-label=""
                    :allow-empty="false"
                    single-select
                    placeholder="เลือกประเภท"
                    @input="onProjectIdChange"
                    style="font-size: 14px"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow">
                      <v-icon class="darkBlue" aria-hidden="false" size="24px">
                        mdi-chevron-down
                      </v-icon>
                    </span>
                  </multiselect>
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="สถานะหน่วยร่วม" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu
                    :options="['หน่วยร่วมที่ปิดแล้ว', 'หน่วยร่วมที่ยังเปิดใช้งาน']"
                    v-model="search.agencytype"
                    item-text="label"
                    item-value="value"
                    @input="onAgencyTypeChange"
                  >
                    <input 
                      name="type" 
                      placeholder="เลือกสถานะหน่วยร่วม"
                      :value="search.agencytype"
                      type="text" 
                      class="depainput rsu mb-0"
                    />
                  </DropdownMenu>
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="สถานะหน่วยร่วม" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu
                    :options="['หน่วยร่วมที่ปิดแล้ว', 'หน่วยร่วมที่ยังเปิดใช้งาน']"
                    v-model="search.agencytype"
                    item-text="label"
                    item-value="value"
                    @input="onAgencyTypeChange"
                  >
                    <input 
                      name="type" 
                      placeholder="เลือกสถานะหน่วยร่วม"
                      :value="search.agencytype"
                      type="text" 
                      class="depainput rsu mb-0"
                    />
                  </DropdownMenu>
                </div>
              </v-flex>
              
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="หน่วยร่วม" />
                <div style="width: 100%" class="form-control">
                  <multiselect
                    :options="agencyList"
                    v-model="search.agencylist"
                    :searchable="true"
                    deselect-label=""
                    :allow-empty="false"
                    single-select
                    placeholder="เลือกหน่วยร่วม"
                    label="agencyname"
                    track-by="id"
                  >
                    <span slot="caret" slot-scope="{ toggle }" class="arrow">
                      <v-icon class="darkBlue" aria-hidden="false" size="24px">
                        mdi-chevron-down
                      </v-icon>
                    </span>
                  </multiselect>
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ผลการตรวจสอบ" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu
                    :options="[
                      'waiting list',
                      'ไม่อนุมัติการสมัครเข้าร่วมโครงการ',
                      'รอเอกสาร',
                      'รอการพิจารณา',
                      'สมัครเข้าร่วมโครงการ',
                      'อนุมัติการสมัครเข้าร่วมโครงการ'
                    ]"
                    v-model="search.applicantstatus"
                    :projectstatustype="true"
                  >
                    <input
                      name="Status"
                      :style="'color: ' + statusColor(search.applicantstatus) + ' !important'"
                      placeholder="เลือกสถานะ"
                      :value="projectStatusLabel(search.applicantstatus)"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </DropdownMenu>
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="สถานะ Odoo" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu
                    :options="['unconfirmed', 'confirm', 'rejected']"
                    v-model="search.status"
                    :statustype="true"
                  >
                    <input
                      name="StatusOdoo"
                      :style="'color: ' + statusColor(search.status) + ' !important'"
                      placeholder="เลือกสถานะ Odoo"
                      :value="statusLabel(search.status)"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </DropdownMenu>
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2 pl-1">
                <Typography class="pr-3" h5 label="รวม Odoo" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="ข้อมูล Odoo"
                    v-model="search.memberid1"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>

              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="ข้อมูล Odoo" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="ข้อมูล Odoo"
                    v-model="search.memberid"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>

              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="pr-3" h5 label="สถานะการจ่ายเงิน" />
                <div style="width: 100%" class="form-control">
                  <DropdownMenu
                    :options="['จ่ายเงินแล้ว', 'ยังไม่จ่ายเงิน']"
                    v-model="search.paymentstatus"
                  >
                    <input
                      name="Payment"
                      placeholder="เลือกสถานะการจ่ายเงิน"
                      :value="search.paymentstatus"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </DropdownMenu>
                </div>
              </v-flex>
            </v-layout>
            <div class="pt-2" style="display: flex; justify-content: center">
              <Button :loading="searchloading" outline :label="$t('Clear')" @click="clearSearch" />
              <Button :loading="searchloading" depressed :label="$t('Save')" @click="onSearch" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFormAddMember" persistent width="800px" height= "10px;">
        <FormAddMember :isDialogOpen="showFormAddMember" @close="showFormAddMember = false"></FormAddMember>
    </v-dialog>

    <v-dialog v-model="showFormDetail" width="800px">
      <v-card v-if="showFormDetail" style="width: 100%">
        <div style="position: relative">
          <div style="position: absolute; right: 0px; top: 0px">
            <v-btn @click="closemodal" icon>
              <v-icon color="#0C2F53" large>close</v-icon>
            </v-btn>
          </div>
          <FormDetail
            :currentdata="currentData"
            @reload="reload"
            @close="showFormDetail = false"
            :formdataall="currentFormData"
            :projects="projects"
            :currentFormData="currentFormData"
            @saveApplicant="saveApplicant"
            @loadtable="getdepaprojectapplicant"
          ></FormDetail>
          <!-- <v-layout class="mb-0" row wrap justify-center>
                  <v-btn @click="saveApplicant(currentData, currentFormData)" color="primary">
                    บันทึกการแก้ไข
                  </v-btn>
                </v-layout> -->
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPayment" width="450px" persistent>
      <v-card style="border-radius: 10px">
        <div class="pt-4 pb-4 pl-5 pr-5">
          <div style="display: flex; justify-content: space-between">
            <div></div>
            <Typography h2 bold label="ข้อมูลสลิป" />
            <v-icon style="display: flex; align-items: center" @click="showPayment = false"
              >close</v-icon
            >
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs12 class="mb-2 mt-2 pr-1 center">
                <v-img
                  v-if="slipData.slipfile"
                  class="ma-auto"
                  position="'center center'"
                  :width="250"
                  :src="slipData.slipfile ? slipData.slipfile : ''"
                />
                <Typography v-else h3 bold label="ไม่พบข้อมูล" />
              </v-flex>
              <v-flex xs12 class="pl-2 mb-1 mt-2 pr-1 center" style="display: flex">
                <Typography h5 bold label="รหัสอ้างอิง 1 : " />
                <Typography
                  class="ml-2"
                  h5
                  semiBold
                  :label="
                    slipData.qrcode_data && slipData.qrcode_data.ref1 != ''
                      ? slipData.qrcode_data.ref1
                      : 'ไม่พบข้อมูล'
                  "
                />
              </v-flex>
              <v-flex xs12 class="pl-2 center" style="display: flex">
                <Typography h5 bold label="รหัสอ้างอิง 2 : " />
                <Typography
                  class="ml-2"
                  h5
                  semiBold
                  :label="
                    slipData.qrcode_data && slipData.qrcode_data.ref2 != ''
                      ? slipData.qrcode_data.ref2
                      : 'ไม่พบข้อมูล'
                  "
                />
              </v-flex>
              <v-flex xs12 class="center" style="display: flex">
                <div class="amountDetail">
                  <Typography class="ml-2" h6 semiBold label="ยอดที่ต้องชำระ" />
                  <Typography color="color-error" class="ml-2" h7 semiBold label="฿" />
                  <Typography
                    color="color-error"
                    class="ml-2"
                    h1
                    bold
                    :label="slipData.amount && slipData.amount != '' ? slipData.amount : '0'"
                  />
                </div>
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="ml-2" h5 semiBold label="วันที่ชำระเงิน" />
                <Typography
                  class="ml-2"
                  h5
                  :label="
                    slipData.paid_date
                      ? moment(slipData.paid_date).format('DD/MM/YYYY')
                      : 'ไม่พบข้อมูล'
                  "
                />
              </v-flex>
              <v-flex xs6 class="mb-2 mt-2">
                <Typography class="ml-2" h5 semiBold label="เวลาชำระเงิน" />
                <Typography
                  class="ml-2"
                  h5
                  :label="slipData.paid_time ? moment(paid_time).format('HH:mm') : 'ไม่พบข้อมูล'"
                />
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2">
                <Typography class="ml-2" h5 semiBold label="ธนาคารที่ทำการชำระเงิน" />
                <Typography
                  class="ml-2"
                  h5
                  :label="slipData.bankname ? slipData.bankname : 'ไม่พบข้อมูล'"
                />
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import api from '@/api'
import InputSearch from '@/components/elements/InputSearch.vue'
import Paginations from '@/components/elements/Paginations.vue'
import ProjectInfoEdit from '../projectMaster/ProjectInfoEdit.vue'
import MemberInfoEdit from '../memberInfo/MemberInfoEdit.vue'
import FormDetail from '../projectMaster/FormDetailMember.vue'
import FormAddMember from '../projectMaster/FormAddMember.vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import moment from 'moment'
import Exportxlsx from '../../elements/exportxlsx.vue'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Button from '@/components/elements/Button.vue'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import XLSX from 'xlsx'
import _ from 'lodash'
import { uuid } from 'vue-uuid'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  components: {
    ProjectInfoEdit,
    FormDetail,
    MemberInfoEdit,
    DropdownMenu,
    Multiselect,
    Exportxlsx,
    InputSearch,
    TooltipTable,
    Paginations,
    Typography,
    Button,
    FormAddMember,
  },

  data() {
    return {
      imageRefs: {},
      isSearch: false,
      column: [
        'วันที่ / เวลา',
        'ข้อมูลแบบฟอร์ม',
        'เลขที่ใบสมัคร',
        'รหัสสมาชิก',
        'ชื่อ - นามสกุล',
        'สถานะ DP',
        // 'การตรวจสอบ',
        'รหัสโครงการ',
        'โครงการ',
        'ขั้นตอน',
        'ผลการตรวจสอบ',
        'สถานะการจ่ายเงิน',
        'สลิป',
        'อีเมล',
        'เบอร์',
        'ประเภท',
        'สถานะ Odoo',
        'รวม Odoo',
        'ข้อมูล Odoo',

        'ประวัติ'
      ],
      columnAll: [
        'วันที่ / เวลา',
        'ข้อมูลแบบฟอร์ม',
        'เลขที่ใบสมัคร',
        'รหัสสมาชิก',
        'ชื่อ - นามสกุล',
        'สถานะ DP',
        // 'การตรวจสอบ',
        'รหัสโครงการ',
        'โครงการ',
        'ขั้นตอน',
        'ผลการตรวจสอบ',
        'สถานะการจ่ายเงิน',
        'สลิป',
        'อีเมล',
        'เบอร์',
        'ประเภท',
        'สถานะ Odoo',
        'รวม Odoo',
        'ข้อมูล Odoo',
        'ประวัติ'
      ],
      showColumn: [
        'วันที่ / เวลา',
        'ข้อมูลแบบฟอร์ม',
        'เลขที่ใบสมัคร',
        'รหัสสมาชิก',
        'ชื่อ - นามสกุล',
        'สถานะ DP',
        // 'การตรวจสอบ',
        'รหัสโครงการ',
        'โครงการ',
        'ขั้นตอน',
        'ผลการตรวจสอบ',
        'สถานะการจ่ายเงิน',
        'สลิป',
        'อีเมล',
        'เบอร์',
        'ประเภท',
        'สถานะ Odoo',
        'รวม Odoo',
        'ข้อมูล Odoo',
        'ประวัติ'
      ],
      page: 1,
      numberPage: {
        page: undefined
      },
      pageTotal: 0,
      slipData: {},
      showPayment: false,
      showSearch: false,
      showHistory: false,
      tagOptions: [],
      update_tags: [],
      searchloading: false,
      test: false,
      loading: true,
      drawer: false,
      isEdit: false,
      clearAdvancedSearch: false,
      activeLog: [],
      search: {
        nameAll: '',
        name: '',
        institute_name: '',
        memberid: '',
        email: '',
        id_card: '',
        phone_number: '',
        status: '',
        check: '',
        paymentstatus: '',
        type: '',
        projecttype: '',
        dpType: '',
        tags: [],
        agencyname: '',
        depaprojectid: '',
        agencylist: '',
        agencytype: '',
      },
      pagination: {
        sortBy: 'memberid',
        descending: false,
        rowsPerPage: 50
      },
      inputEdit: {},
      filter: {},
      searchColumn: '',
      statusDP: '',
      editModal: false,
      modalStatusDP: false,
      modalExport: false,
      modalStatusDPEdit: {},
      searchModal: false,
      desserts: [],
      headers: [
        {
          text: 'วันที่ / เวลา',
          align: 'center',
          value: 'date_time'
        },
        {
          text: 'ข้อมูลแบบฟอร์ม',
          align: 'center',
          value: 'form_data'
        },
        {
          text: 'เลขที่ใบสมัคร',
          align: 'left',
          value: 'form_data'
        },
        {
          text: 'รหัสสมาชิก',
          align: 'left',
          value: 'memberid'
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'left',
          value: 'name'
        },
        {
          text: 'สถานะ DP',
          align: 'center',
          value: 'dptype'
        },
        // {
        //   text: 'การตรวจสอบ',
        //   align: 'center',
        //   value: 'check'
        // },
        {
          text: 'รหัสโครงการ',
          align: 'left',
          value: 'depaprojectid'
        },
        {
          text: 'โครงการ',
          align: 'left',
          value: 'projectname'
        },
        {
          text: 'ขั้นตอน',
          align: 'left',
          value: 'applicantstepstatus'
        },
        {
          text: 'ผลการตรวจสอบ',
          align: 'left',
          value: 'tags'
        },
        {
          text: 'สถานะการจ่ายเงิน',
          align: 'center',
          value: 'status'
        },
        {
          text: 'สลิป',
          align: 'center',
          value: ''
        },
        {
          text: 'อีเมล',
          align: 'left',
          value: 'email'
        },
        {
          text: 'เบอร์',
          align: 'left',
          value: 'phone_number'
        },
        {
          text: 'ประเภท',
          align: 'left',
          value: 'membertype'
        },
        {
          text: 'สถานะ Odoo',
          align: 'center',
          value: 'odoo_status',
          sortable: false
        },
        {
          text: 'รวม Odoo',
          align: 'center',
          value: 'odoo_total',
          sortable: false
        },
        {
          text: 'ข้อมูล Odoo',
          align: 'center',
          value: 'odoo_info',
          sortable: false
        },
        {
          text: 'ประวัติ',
          align: 'center',
          value: ''
        },
        {
          text: '',
          align: 'center',
          value: ''
        }
      ],
      firstUserId: [],
      membertype: [],
      currentOdoo: '',
      modalOdoo: false,
      exdata: [],
      agencyList: [],
      projectsList: [],
      showFormDetail: false,
      showFormAddMember: false,
    }
  },
  computed: {
    xlsxMember() {
      var result = this.exdata.map(el => {
        return {
          'เลขรหัสสมาชิก depa member': el.memberid,
          ชื่อบริษัท: this.filteredName(el) || el.name || el.institute_name,
          'เลขบัตรประชาชน/เลขนิติบุคคล': el.id_card,
          จังหวัด: '',
          ข้อมูลบริษัท: el.detail,
          รูปภาพรูปโลโก้บริษัท: el.profile_pic,
          ชื่อผู้ประสานงาน: el.coordinator_name,
          อีเมล์: el.email,
          เบอร์โทรศัพท์: el.phone_number,
          หน่วยงาน: el.institute_name,
          แท็ก: el.tags,
          'สถานะ DP': el.dptype,
          'Member Type': el.membertype,
          สถานะ: el.status,
          website: el.website,
          'ชื่อผลิตภัณฑ์ และ ราคา': el.productlist,
          'สถานะ Odoo': el.odooinfo ? el.odooinfo[1].plan_status : '',
          'Odoo total amount': el.odooinfo && el.odooinfo.total ? el.odooinfo.total : '',
          'ข้อมูล Odoo': el.odooinfo ? JSON.stringify(el.odooinfo) : ''
        }
      })
      return result
    },
    pageCount() {
      if (this.desserts && this.pageTotal) {
        let count = Math.ceil(this.pageTotal / this.pagination.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.pagination.rowsPerPage
    },
    offsetCom() {
      return this.page
        ? this.page * this.pagination.rowsPerPage - this.pagination.rowsPerPage
        : this.pagination.rowsPerPage
    },
    projecttype() {
      if (
        this.$store.state.privilege.role == 'agency' &&
        this.$store.state.privilege.project !== undefined &&
        this.$store.state.privilege.project.length !== 0
      ) {
        let ids = this.$store.state.privilege.project.map(x => {
          return x.typeid
        })
        let output = []
        this.$store.state.projecttype.forEach(ele => {
          if (ids.includes(ele.id)) {
            output.push(ele)
          }
        })
        return output
      } else {
        return this.$store.state.projecttype
      }
    },
    projectOptions() {
      var result = []
      if (this.search.projecttype && this.search.projecttype.id) {
        result = this.projectsList.filter(el => el.typeid === this.search.projecttype.id)
      } else {
        result = this.projectsList
      }
      let newAllProjectId = (result || []).map(item => item.id)
      let arrProjectId = [...newAllProjectId]
      result = arrProjectId
      return result
    },
    projectIdOptions() {
      var result = []
      if (this.search.projecttype && this.search.projecttype.id) {
        result = this.projectsList.filter(el => el.typeid === this.search.projecttype.id)
      } else {
        result = this.projectsList
      }
      let newAllProjectId = (result || []).map(item => item.depaprojectid)
      let newArrProjectId = new Set(newAllProjectId)
      let arrProjectId = [...newArrProjectId]
      let arrProjectIdData = arrProjectId.filter(str => str !== '')
      result = arrProjectIdData
      return result
    },
    moment() {
      return moment
    },
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    this.loading = true
    await this.getAgency()
    if (
      this.$store.state.privilege.role === 'agency' &&
      this.$store.state.privilege.project !== undefined &&
      this.$store.state.privilege.project.length !== 0
    ) {
      this.projectsList = this.$store.state.privilege.project
    } else {
      await this.getProject()
    }
    await this.getProjectType()
    await this.getdepaprojectapplicant()
    this.getdepamembertypeall()
    this.loading = false
  },
  methods: {
    async saveApplicant(data, form) {
      let body = {
        applicantid: data.applicantid,
        memberid: data.memberid,
        stepid: Object.keys(form)[0] ? Object.keys(form)[0] : null,
        formdata: JSON.stringify(form[Object.keys(form)[0]][0])
      }
      let resStatus = await api.updateApplicantDetail(body)
      // console.log('resStatus',resStatus)
      if (resStatus) {
        this.$swal.fire({
          title: 'บันทึกข้อมูลสำเร็จ',
          type: 'success'
        })
      } else {
        await this.$swal.fire({
          type: 'error',
          title: 'บันทึกข้อมูลไม่สำเร็จ'
        })
      }
    },
    async clickShowLog(applicantid) {
      let res = await api.getApplicantLog(applicantid)
      if (res) {
        if (typeof res == 'string') {
          this.$swal.fire({
            type: 'error',
            text: res
          })
        } else {
          this.showHistory = true
          this.activeLog = res
        }
      } else {
        this.$swal.fire({
          type: 'error',
          text: 'API ERROR'
        })
      }
    },
    async checkPaymentTransaction(id) {
      let res = await api.postPaymentSlipData(id)
      this.slipData = res.data.data
      this.showPayment = true
    },
    async deleteApplicant(id) {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ต้องการที่จะลบใช่หรือไม่</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.deleteApplicant(id)
            // console.log('res', res)
            if (res.status === 200) {
              await this.getdepaprojectapplicant()
              this.$swal.fire({
                title: '<div class="headline primary--text bold7 fs-24">ลบข้อมูลสำเร็จ</div>',
                showCancelButton: false,
                showCloseButton: true
              })
            } else {
              this.$swal.fire('ลบข้อมูลไม่สำเร็จ')
            }
          }
        })
    },
    async getAgency() {
      let resData = await api.getAgency()
      if (resData && resData.responsecode == 200) {
        if (
          this.$store.state.privilege.role == 'agency' &&
          this.$store.state.privilege.agency !== undefined &&
          this.$store.state.privilege.agency.length !== 0
        ) {
          this.agencyList = this.$store.state.privilege.agency
          this.agency = this.$store.state.privilege.agency.map(x => {
            return x.agencyname
          })
        } else {
          this.agencyList = resData.data
          this.agency = resData.data.map(x => {
            return x.agencyname
          })
        }
      }
    },
    getProject() {
      return new Promise(resolve => {
        api.getdepaproject({}, (err, response) => {
          if (response.responsecode == 200) {
            this.projectsList = response.data
            resolve()
          }
        })
      })
    },
    getProjectType() {
      return new Promise(resolve => {
        api.getdepaprojecttype({}, (err, response) => {
          if (response.responsecode == 200) {
            this.$store.state.projecttype = response.data.map(el => {
              return { ...el, typedata: JSON.parse(el.typedata) }
            })
          }
          resolve()
        })
      })
    },
    async depafirstAllowMember() {
      let resData = await api.depafirstAllowMember()
      this.firstUserId = resData ? resData : []
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getdepaprojectapplicant()
      this.loading = false
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      // this.$refs.exbtn.exportxlsx()
      this.loading = false
    },
    goToLivechat: function(id) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: id
        }
      })
      window.open(routeData.href, '_blank')
    },
    printUser(item) {
      let contents = this.buildPDFContent(item)
      var dd = {
        content: [...contents],
        styles: {
          header: {
            fontSize: 20,
            color: '#ff5656',
            bold: true
          },
          paragraph: {
            fontWeight: 200
          },
          container: {
            margin: [10, 10, 10, 10]
          },
          receipt: {
            fontSize: 18,
            color: '#ff5656',
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew'
        },
        images: {
          ...this.imageRefs,
          checked:
            'data:image/png;base64,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',
          unchecked:
            'data:image/png;base64,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'
        }
      }
      pdfMake.createPdf(dd).open()
    },
    convertToBase64(url) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.onload = function() {
          var reader = new FileReader()
          reader.onloadend = function() {
            resolve(reader.result)
          }
          reader.readAsDataURL(xhr.response)
        }
        xhr.onerror = function(e) {
          reject(e)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      })
    },
    printUserExcel(item) {
      let projectForm = this.projectsList.find(x => {
        return Number(x.id) === Number(item.projectid)
      })
      // console.log('projectForm', projectForm)
      let projecttype = this.projecttype.find(x => {
        return Number(x.id) === Number(projectForm.typeid)
      })
      // console.log('projecttype', projecttype)
      try {
        projectForm = JSON.parse(projectForm.projectdata)
      } catch (error) {
        console.error(error)
        projectForm = []
      }
      let typedata = []
      projecttype.typedata.forEach(ele1 => {
        ele1.steps.forEach(ele2 => {
          typedata.push(ele2)
        })
      })
      let formdata = item.formdata
      let output = []
      let stepDataTemp = []
      if (formdata) {
        for (const key in formdata) {
          formdata[key].forEach(ele1 => {
            stepDataTemp.push({ name: ele1.formname })
            if (ele1.length != undefined) {
              ele1.forEach(ele2 => {
                let data = {
                  Type: ele2.questiontype,
                  name: ele2.name,
                  value: ele2.value
                }
                if (ele2.value2) {
                  data.value2 = ele2.value2
                }
                stepDataTemp.push(data)
              })
            } else {
              ele1.formitems.forEach(ele2 => {
                let data = {
                  Type: ele2.questiontype,
                  name: ele2.name,
                  value: ele2.value
                }
                if (ele2.value2) {
                  data.value2 = ele2.value2
                }
                stepDataTemp.push(data)
              })
            }
          })
        }
        output.push(stepDataTemp)
      }
      const wb = XLSX.utils.book_new()
      output.forEach((step, index) => {
        const dataWS = XLSX.utils.json_to_sheet(step)
        let name = `${output.length - index}-${projectForm.length} ${
          typedata[output.length - 1 - index].name
        }`
        if (name.length > 30) {
          name = name.substring(0, 30)
        }
        XLSX.utils.book_append_sheet(wb, dataWS, name)
      })
      XLSX.writeFile(wb, 'export.xlsx')
    },
    buildPDFContent(item) {
      let formdata = _.cloneDeep(item.formdata)
      let steps = this.getAllForm(formdata)
      let contents = []
      steps.forEach((step, index) => {
        let headers = [
          {
            text: step.projectname ? step.projectname : 'ชื่อโครงการ',
            bold: true,
            fontSize: 21
          },
          {
            text: `Step - ${index + 1}/${steps.length}`
          },
          {
            text: `ผู้สมัคร - ${this.filteredName(step.profiledata)}`
          },
          {
            text: moment(step.timestamp).format('DD/MM/YYYY HH:mm') + '\n\n'
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }] },
          {
            text: '\n'
          }
        ]

        let form = []
        step._formitems.forEach((item, iindex) => {
          if (item) {
            let _item = Object.prototype.toString.call(item) === '[object Array]' ? item : [item]
            _item.forEach(question => {
              let contents = this.formatContent(question)
              form = [...form, ...contents]
            })
          }
          if (step._formitems.length - 1 == iindex && steps.length - 1 != index) {
            form.push({
              text: '',
              pageBreak: 'after'
            })
          }
        })
        // if (step.length - 1 != index) {
        //   form.push({
        //     text: '',
        //     pageBreak: 'after'
        //   })
        // }

        contents = [...contents, ...headers, ...form]
      })
      return contents
    },
    buildSubPDFContent(result) {
      let form = []
      result.forEach(el => {
        let contents = this.formatContent(el)
        form = [...form, ...contents]
      })
      return form
    },
    formatContent(question) {
      let form = []
      if (['หัวข้อ', 'title', 'พารากราฟ', 'บทความ'].includes(question.questiontype)) {
        if (['พารากราฟ', 'บทความ'].includes(question.questiontype)) {
          form.push({
            text: question.name,
            margin: [0, 10, 0, 0]
          })
        } else if (['หัวข้อ'].includes(question.questiontype)) {
          form.push({
            text: question.name,
            bold: true,
            fontSize: 19,
            margin: [0, 10, 0, 0]
          })
        }
      } else {
        form.push({
          text: question.name,
          bold: true,
          margin: [0, 5, 0, 0]
        })
      }
      if (['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ', 'เลื่อนลง'].includes(question.questiontype)) {
        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: question.value || ' ', color: 'grey', margin: 3 }]]
          },
          margin: [0, 0, 0, 5]
        })
      } else if (['ตัวเลข'].includes(question.questiontype)) {
        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: question.value || ' ', color: 'grey' }]]
          },
          margin: [0, 0, 0, 5]
        })
      } else if (['ตัวอย่างไฟล์'].includes(question.questiontype)) {
        form.push({
          table: {
            widths: ['100%'],
            body: [
              [{ text: question.filename || 'file', link: question.fileurl || '', color: 'grey' }]
            ]
          },
          margin: [0, 0, 0, 5]
        })
      } else if (['ที่อยู่'].includes(question.questiontype)) {
        let address = {
          addressno: '',
          district: '',
          amphoe: '',
          province: '',
          zipcode: ''
        }
        try {
          if (typeof question.value == 'object') {
            address = question.value
          } else {
            address = JSON.parse(question.value)
          }
        } catch (error) {
          console.log(error)
        }
        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: address.addressno || ' ', color: 'grey' }]]
          },
          margin: [0, 0, 0, 5]
        })

        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: address.zipcode || ' ', color: 'grey' }]]
          },
          margin: [0, 0, 0, 5]
        })

        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: address.province || ' ', color: 'grey' }]]
          },
          margin: [0, 0, 0, 5]
        })

        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: address.amphoe || ' ', color: 'grey' }]]
          },
          margin: [0, 0, 0, 5]
        })

        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: address.district || ' ', color: 'grey' }]]
          },
          margin: [0, 0, 0, 5]
        })
      } else if (question.questiontype == 'หลายตัวเลือก') {
        // radio
        question.fields.forEach(checkbox => {
          let data = [
            [
              {
                margin: [-3, 7, 0, 0],
                border: [false, false, false, false],
                image: question.value == checkbox.label ? 'checked' : 'unchecked',
                width: 6
              },
              {
                margin: [-3, 5, 0, 0],
                border: [false, false, false, false],
                fontSize: 7,
                text: checkbox.label
              }
            ]
          ]
          if (checkbox.subquestion && checkbox.subquestion.length > 0) {
            data.push([
              { text: '', border: [false, false, false, false] },
              {
                stack: this.buildSubPDFContent(checkbox.subquestion),
                border: [false, false, false, false]
              }
            ])
          }

          form.push([
            {
              table: {
                widths: ['1%', '99%'],
                body: data
              }
            }
          ])
        })
      } else if (question.questiontype == 'ช่องทำเครื่องหมาย') {
        question.fields.forEach(checkbox => {
          let data = [
            [
              {
                margin: [-3, 7, 0, 0],
                border: [false, false, false, false],
                image: question.value.indexOf(checkbox.label) != -1 ? 'checked' : 'unchecked',
                width: 6
              },
              {
                margin: [-3, 5, 0, 0],
                border: [false, false, false, false],
                fontSize: 7,
                text: checkbox.label
              }
            ]
          ]
          if (checkbox.subquestion && checkbox.subquestion.length > 0) {
            data.push([
              { text: '', border: [false, false, false, false] },
              {
                stack: this.buildSubPDFContent(checkbox.subquestion),
                border: [false, false, false, false]
              }
            ])
          }

          form.push([
            {
              table: {
                widths: ['1%', '99%'],
                body: data
              }
            }
          ])
        })
      }

      // else if (question.questiontype == 'เลื่อนลง') {
      //   // dropdown
      // }
      else if (question.questiontype == 'วัน/เวลา') {
        let columns = []
        if (['all', 'date'].includes(question.Options)) {
          columns.push({
            table: {
              widths: ['100%'],
              body: [[question.value ? moment(question.value).format('DD/MM/YYYY') : ' ']]
            },
            margin: [0, 0, 0, 5]
          })
        }
        if (['all', 'time'].includes(question.Options)) {
          columns.push({
            table: {
              widths: ['100%'],
              body: [[question.value2 ? question.value2 : ' ']]
            },
            margin: [0, 0, 0, 5]
          })
        }
        form.push({
          columns: columns
        })
      } else if (
        ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(question.questiontype)
      ) {
        if (typeof question.value == Array || typeof question.value == 'object') {
          let files = question.value.map(file => ({ text: file, link: file }))
          form.push({
            ul: files
          })
        } else {
          form.push({
            ul: [{ text: question.value, link: question.value }]
          })
        }
      } else if (question.questiontype == 'รายการผลิตภัณฑ์') {
        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: ' ', color: 'grey', margin: 3 }]]
          },
          margin: [0, 0, 0, 5]
        })
      } else if (question.questiontype == 'แนบลิงก์') {
        form.push({
          ul: [{ text: question.URL, link: question.URL }]
        })
      } else if (question.questiontype == 'ช่องกรอกลิงก์') {
        form.push({
          table: {
            widths: ['100%'],
            body: [[{ text: question.value || ' ', color: 'grey', margin: 3 }]]
          },
          margin: [0, 0, 0, 5]
        })
      } else if (question.questiontype == 'รูปภาพ') {
        // console.log('questiontype', question, question.imgFile)
        if (question.imgFile) {
          const id = uuid.v4()
          this.imageRefs[id] = question.imgFile
          // console.log('this.imageRefs[id]', this.imageRefs[id])
          form.push({
            image: id,
            width: 350
          })
        }

        // let b64 = question.imgFile
        // this.imageToBase64(b64)
        //   .then(base64String => {
        //     if (base64String) {
        //       console.log('b64', base64String)
        //       form.push({
        //         image: base64String,
        //         width: 150,
        //         height: 150
        //       })
        //     } else {
        //     }
        //   })
        //   .catch(error => {
        //     console.error('Error:', error)
        //   })
      } else if (question.questiontype == 'ตาราง') {
        // console.log('question', question.formTable)
        if (question.formTable.viewColumn) {
          const asterisksArray = Array(question.formTable.data[0].length).fill('*')
          form.push({
            table: {
              widths: asterisksArray,
              body: question.formTable.data
            },
            margin: [0, 0, 0, 5]
          })
        } else {
          let cloneArr = question.formTable.data
          const result = cloneArr.map(subArray => subArray.slice(1))
          const asterisksArray = Array(result[0].length).fill('*')
          form.push({
            table: {
              widths: asterisksArray,
              body: result
            },
            margin: [0, 0, 0, 5]
          })
        }
      }
      // console.log('form', form)
      return form
    },
    imageToBase64(url) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.crossOrigin = 'Anonymous'
        image.onload = function() {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          const context = canvas.getContext('2d')
          context.drawImage(image, 0, 0)
          const base64String = canvas.toDataURL('image/jpeg')
          resolve(base64String)
        }
        image.onerror = reject
        image.src = url
      })
    },
    isObject(value) {
      return typeof value === 'object' && !Array.isArray(value) && value !== null
    },
    getAllForm(formdata) {
      let items = []
      Object.entries(formdata).forEach(([key, value], index) => {
        items.push({
          ...value[0],
          projectname: Object.values(formdata)[0][0].projectname,
          stepid: key
        })
        // if (index == 0) {
        //   items.push({
        //     ...value[0],
        //     stepid: key
        //   })
        // } else {
        //   items.push({
        //     formitems: value[0],
        //     stepid: key
        //   })
        // }
      })
      items.forEach(step => {
        var formitems = this.buildStepData(step.formitems)
        step._formitems = formitems || []
      })
      return items
    },
    buildStepData(result) {
      if (result != undefined) {
        if (result.some(el => el.questiontype == 'หน้าถัดไป')) {
          var data = []
          var count = 0
          // eslint-disable-next-line no-continue
          result.forEach(el => {
            if (el.questiontype == 'หน้าถัดไป') {
              count += 1
            } else {
              // eslint-disable-next-line no-continue4
              if (data[count]) {
                data[count].push(el)
              } else {
                data.push([el])
              }
            }
          })
          return data
        } else {
          return result
        }
      }
    },
    filteredName(item) {
      if (item != undefined) {
        if (item.name) {
          return item.name
        } else if (item.coordinator_name) {
          return item.coordinator_name
        } else if (item.institute_name) {
          return item.institute_name
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    async showOdooInfo(odooItem, memberid) {
      // this.loading = true
      const id = parseInt(memberid)
      let res = await api.getProjectByMemberid(id)
      if (res) {
        let idList = res.map(x => {
          if (x.depaprojectid) {
            return x.depaprojectid
          }
        })
        if (idList && idList.length) {
          let data = []
          idList.forEach(async id => {
            let resOdoo = await api.getOdooData(id)
            resOdoo = resOdoo.data
            if (resOdoo) {
              data.push(JSON.parse(resOdoo))
            }
          })
          this.currentOdoo = data
        } else {
          this.currentOdoo = []
        }
        // this.loading = false
        this.modalOdoo = true
      }
    },
    addTag(newTag, k) {
      const tag = newTag
      this.tagOptions.push(tag)

      this.search.tags.push(tag)
      this.update_tags.push(tag)
    },
    nametype(data) {
      return data.type
    },
    getdepamembertypeall() {
      // console.log('this.selectedBot.pageid', this.selectedBot.pageid)
      api.getdepamembertypeall({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          this.membertype = response.data
          this.$store.state.depamembertype = response.data
        }
      })
    },
    async statusPaymentEdit(id, item) {
      // console.log("statusPaymentEdit", id, item)
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">เปลี่ยนสถานะการจ่ายเงิน</div>',
          html: `<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนสถานะเป็น</div><div class="primary--text fs-16">“${item}”</div>`,
          showCancelButton: true,
          showCloseButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.postChangePaymentStatus(id, item)
            if (res.status === 200) {
              await this.getdepaprojectapplicant()

              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                text: `${moment(new Date()).format('DD/MM/YY') +
                  ' ' +
                  moment(new Date()).format('HH:mm')}`,
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
            }
          }
        })
    },
    rejectMember(item) {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ปฏิเสธ</div>',
          html:
            '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธการยืนยันตัวตนนี้</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.value) {
            api.depaadminrejectmemberregister({ memberid: item.memberid }, (err, response) => {
              this.getdepamemberinfoall()
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                text: `${moment(new Date()).format('DD/MM/YY') +
                  ' ' +
                  moment(new Date()).format('HH:mm')}`,
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
            })
          }
        })
    },
    verifyMember(item) {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ยืนยันตัวตน</div>',
          html:
            '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการยืนยันตัวตนรายการนี้</div>',
          showCancelButton: true,
          showCloseButton: true
        })
        .then(result => {
          if (result.value) {
            api.depaUpdateStatusMemberRejectToConfirm(
              { memberid: item.memberid },
              (err, response) => {
                this.getdepamemberinfoall()
                this.$swal.fire({
                  type: 'success',
                  title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
                  text: `${moment(new Date()).format('DD/MM/YY') +
                    ' ' +
                    moment(new Date()).format('HH:mm')}`,
                  confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
                })
              }
            )
          }
        })
    },
    statusDPEdit(item) {
      this.modalStatusDP = true
      this.modalStatusDPEdit = item
      this.statusDP = item.dptype
    },
    async editStatusDP() {
      try {
        await this.$store.dispatch('depamemberinfo', {
          ...this.modalStatusDPEdit,
          dptype: this.statusDP
        })
        this.getdepaprojectapplicant()
        this.modalStatusDP = false
        this.$swal.fire({
          type: 'success',
          title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
          text: `${moment(new Date()).format('DD/MM/YY') +
            ' ' +
            moment(new Date()).format('HH:mm')}`,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      } catch (error) {}
    },
    changeSearchColumn(name) {
      let outputResult
      if (name.target._value !== '') {
        outputResult = this.columnAll.filter(item => {
          return item.toLowerCase().indexOf(name.target._value.toLowerCase()) !== -1
        })
      } else {
        outputResult = this.columnAll.filter(item => {
          return item
        })
      }
      this.column = outputResult
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.pagination.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      this.page = parseInt(pages)
      this.loading = true
      await this.getdepaprojectapplicant()
      this.loading = false
    },
    clearSearchColumn() {
      this.searchColumn = ''
      this.column = this.columnAll
    },
    clickShowColumn(item) {
      if (this.showColumn.includes(item)) {
        var filterCheckbox = this.showColumn.filter(result => result !== item)
        this.showColumn = filterCheckbox
      } else {
        this.showColumn.push(item)
      }
    },
    onProjectTypeChange(option) {
      if (option) {
        this.$set(this.search, 'projectid', '')
        this.$set(this.search, 'depaprojectid', '')
        this.$nextTick(() => {})
      }
    },
    onDepaProjectIdChange(option) {
      if (option) {
      }
    },
    onProjectIdChange(option) {
      if (option) {
        this.$nextTick(() => {})
      }
    },
    async clearSearch() {
      this.clearAdvancedSearch = false
      this.search = {
        nameAll: '',
        name: '',
        institute_name: '',
        memberid: '',
        email: '',
        id_card: '',
        phone_number: '',
        status: '',
        check: '',
        paymentstatus: '',
        type: '',
        projecttype: '',
        dpType: '',
        tags: [],
        agencyname: '',
        projectid: '',
        depaprojectid: '',
        agencylist: '',
        agencytype: ''
      }

      this.isSearch = false
      this.loading = true
      this.searchloading = true
      this.page = 1
      await this.getdepaprojectapplicant()
      this.searchloading = false
      this.showSearch = false
      this.loading = false
    },
    async onSearch() {
      this.isSearch = true
      this.loading = true
      this.searchloading = true
      this.page = 1
      await this.getdepaprojectapplicant()
      this.searchloading = false
      this.showSearch = false
      this.loading = false
    },
    statusColor(item) {
      if (item == 'confirm') {
        return '#67AD5B'
      } else if (item == 'unconfirmed') {
        return '#818181'
      } else if (item == 'rejected') {
        return '#F10606'
      } else if (item == 'pending') {
        return '#FF8A00'
      } else return item
    },
    statusLabel(item) {
      if (item == 'confirm') {
        return 'ตรวจสอบแล้ว' // 'Verified'
      } else if (item == 'unconfirmed') {
        return 'ยังไม่ตรวจสอบ' //'Waiting'
      } else if (item == 'rejected') {
        return 'ปฏิเสธการยืนยันตัวตน' //'Rejected'
      } else if (item == 'pending') {
        return 'รออนุมัติ' // 'Pending'
      } else return item
    },
    projectStatusLabel(item) {
      if (item == 'confirm') {
        return 'อนุมัติแล้ว'
      } else if (item == 'unconfirmed') {
        return 'ยังไม่ได้ตรวจสอบ'
      } else if (item == 'rejected') {
        return 'ไม่อนุมัติ'
      } else if (item == 'pending') {
        return 'อยู่ระหว่างพิจรณา'
      } else return item
    },
    checkLabel(item) {
      if (item == 'uncheck') {
        return 'ยังไม่ได้ตรวจสอบ' // 'uncheck'
      } else if (item == 'waitingdocument') {
        return 'รอเอกสาร' //'waitingdocument'
      } else if (item == 'sentcheck') {
        return 'ส่งตรวจสอบ' //'sentcheck'
      } else if (item == 'checked') {
        return 'ตรวจสอบแล้ว' //'checked'
      } else return item
    },
    customLabel(opt) {
      var project = this.projectsList.find(x => {
        return x.id == opt
      })
      if (project) {
        return project.projectname
      } else {
        return ''
      }
    },
    customLabelID(opt) {
      var project = this.projectsList.find(x => {
        return x.id == opt.id
      })
      if (project) {
        return project.id
      } else {
        return ''
      }
    },
    getdepaprojectapplicant() {
      return new Promise(resolve => {
        var search = {}
        var countSearch = 0
        for (const [key, value] of Object.entries(this.search)) {
          if (key == 'agencyname' && typeof value == 'object') {
            Object.assign(search, { ['agencyid']: value.id })
          } else if (value) {
            Object.assign(search, { [key]: value })
          }
          if (value && key != 'tags') {
            countSearch++
          }
        }

        // clear search advanced
        if (countSearch > 0 || search.tags.length > 0) {
          this.clearAdvancedSearch = true
        } else {
          this.clearAdvancedSearch = false
        }

        if (search.projecttype != undefined) search.projecttype = search.projecttype.id
        const searchData = {
          ...search,
          agencylist: search.agencylist ? search.agencylist.id : null,
          // depaprojectid: search.depaprojectid ? search.depaprojectid.id : null,
          timestamp: search.date ? moment(search.date).format('YYYY-MM-DD') : null,
          pageid: this.selectedBot.pageid,
          limit: this.limitCom,
          offset: this.offsetCom
        }

        if (search.date) {
          searchData.timestamp = search.date ? moment(search.date).format('YYYY-MM-DD') : ''
        }

        if (
          !searchData.projectid &&
          this.$store.state.privilege.role === 'agency' &&
          this.$store.state.privilege.project !== undefined &&
          this.$store.state.privilege.project.length !== 0
        ) {
          let projectslist = this.projectsList.map(project => {
            return project.id
          })
          searchData.projectid = projectslist.join(',')
        }

        if (
          !searchData.agencylist &&
          this.$store.state.privilege.role === 'agency' &&
          this.$store.state.privilege.agency !== undefined &&
          this.$store.state.privilege.agency.length !== 0
        ) {
          let agencylist = this.agencyList.map(agency => {
            return agency.id
          })
          agencylist = agencylist.join(',')
          searchData.agencylist = agencylist
        }

        delete searchData.date

        api.getdepaprojectapplicant(searchData, (err, response) => {
          this.desserts = response.data
          this.pageTotal = response.total
          resolve()
        })
      })
    },
    getdepamemberinfoall() {
      return new Promise(resolve => {
        var search = {}
        var countSearch = 0
        for (const [key, value] of Object.entries(this.search)) {
          if (key == 'agencyname' && typeof value == 'object') {
            Object.assign(search, { ['agencyid']: value.id })
          } else if (value) {
            Object.assign(search, { [key]: value })
          }
          if (value && key != 'tags') {
            countSearch++
          }
        }

        // clear search advanced
        if (countSearch > 0 || search.tags.length > 0) {
          this.clearAdvancedSearch = true
        } else {
          this.clearAdvancedSearch = false
        }

        api.getdepamemberinfoall(
          {
            pageid: this.selectedBot.pageid,
            ...search,
            limit: this.limitCom,
            offset: this.offsetCom
          },
          (err, response) => {
            this.desserts = response.data
            resolve()
          }
        )
      })
    },
    // getExData() {
    //   return new Promise(resolve => {
    //     var search = {}
    //     for (const [key, value] of Object.entries(this.search)) {
    //       if (value) {
    //         Object.assign(search, { [key]: value })
    //       }
    //     }
    //     let projectslist = this.projects.map(project => {
    //       return project.id
    //     })
    //     api.getExcelReport(
    //       {
    //         isexport: true,
    //         pageid: this.selectedBot.pageid,
    //         ...search,
    //         projectid: projectslist.join(',')
    //       },
    //       (err, response) => {
    //         console.log('response',response)
    //         this.exdata = response.data
    //         resolve()
    //         if (response) {
    //           this.modalExport = false
    //         }
    //       }
    //     )
    //   })
    // },
    async getExData() {
      var search = {}
      for (const [key, value] of Object.entries(this.search)) {
        if (value) {
          Object.assign(search, { [key]: value })
        }
      }

      let res = await api.getExcelReport({
        isexport: true,
        pageid: this.selectedBot.pageid,
        ...search,
        projecttype: this.search.projecttype.id ? this.search.projecttype.id : undefined
      })
      if (res) {
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.click()
        URL.revokeObjectURL(link.href)
        this.modalExport = false
      }
    },
    async saveedit(item) {
      var index = this.desserts.findIndex(el => el.memberid == item.memberid)
      this.$set(this.desserts, index, item)

      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
        text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')}`,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
      })

      this.editModal = false
    },
    closemodal() {
      this.editModal = false
      this.searchModal = false
      this.showFormDetail = false
    },
    async showEdit(item) {
      this.inputEdit = item
      await this.$nextTick()
      this.editModal = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    showName(item) {
      if (item.name) {
        return item.name
      } else if (item.coordinator_name) {
        return item.coordinator_name
      } else {
        return item.institute_name
      }
    },
    showForm(item) {
      if (item.applicantstatus == 'ยกเลิกเข้าร่วมโครงการ') {
        return
      }
      this.currentFormData = item.formdata
      this.currentData = item
      this.showFormDetail = true
    },
    async onAgencyTypeChange() {
      if (this.search.agencytype === 'หน่วยร่วมที่ปิดแล้ว') {
        let resData = await api.getAgencyClose()
          this.agencyList = resData.data

      } else if (this.search.agencytype === 'หน่วยร่วมที่ยังเปิดใช้งาน') {
        let resData = await api.getAgencyOpen()
        
          this.agencyList = resData.data
          
          
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.amountDetail {
  background-color: #eaf1ff;
  height: 50px;
  width: 100%;
  border-radius: 10px;
  display: flex;
  align-items: baseline;
  justify-content: end;
  padding: 5px 10px;
}
.v-input {
  padding: 0;
  margin: 0;
}
.text-red {
  color: red;
}
//for fix column table by Tada
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background-color: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMember/main.vue